import { valueof } from '../Common';
import { PULL_REQUEST_STATUS } from '../LibraryComponent';

/**
 * @param newRef 新しく作られるブランチ名。完全ブランチ名(refs/heads/branchname等)表現でない場合は'refs/heads/'を修飾して実行する
 * @param ref ブランチ元となるブランチ名/commit oid
 */
export interface CreateBranchDto {
  readonly newRef: string;
  readonly ref: string;
  readonly projectId: number;
}

export interface FindBranchesQueryDto {
  'project-id': number;
}

/**
 * @param ref 削除対象のブランチ名
 */
export interface DeleteBranchDto {
  readonly repositoryInfoId: number;
  readonly projectId: number;
  readonly branchName: string;
}

/**
 * @param dryRun 実際のマージを行わない（コンフリ確認時に使用）
 * @param production 実際のマージを行う
 */
export const MergeBranchMode = {
  dryRun: 'dry-run',
  production: 'production',
} as const;

export interface MergeBranchQueryDto {
  'execution-mode': valueof<keyof typeof MergeBranchMode>;
}

/**
 * @param ourRef マージを受け入れる側のcommit oidまたはブランチ名、タグ名
 * @param theirRef マージに取り込まれる側のcommit oidまたはブランチ名、タグ名
 * @param message マージのコミットに登録されるメッセージ
 */
export interface MergeBranchDto {
  readonly projectId: number;
  readonly ourRef: string;
  readonly theirRef: string;
  readonly message: string;
}

export interface FindBranchesDetail {
  readonly oid: string;
  readonly branchName: string;
  readonly updatedAt: number;
  readonly pullRequestId: number | null;
  readonly pullRequestStatus: valueof<keyof typeof PULL_REQUEST_STATUS> | null;
}

export interface FindBranchesResponse {
  readonly results: FindBranchesDetail[];
}

export interface MergeBranchResponse {
  readonly isConflict: boolean;
  readonly alreadyMerged?: boolean | undefined;
}

/**最初に作られるブランチ名が変更される可能性を考慮して定数で持っておく */
export const DefaultBranchName = {
  main: 'main',
} as const;
